import React, { Component } from 'react'
import PropTypes from 'prop-types'
import AdminTableComponent from 'routes/Admin/components/CommonComponents/AdminTableComponent'
import { MODAL_ADMIN_EDIT_TAXE } from 'redux/modules/modals'
const percentValue = value => value * 100
const booleanValue = value => !!Number(value)
const defaultColumnData = [
  { id: 'tax_name', numeric: false, disablePadding: false, label: 'Nom' },
  {
    id: 'tax_value',
    numeric: true,
    float: 2,
    disablePadding: false,
    label: 'Valeur',
    transform: percentValue
  },
  {
    id: 'tax_default',
    bool: true,
    disablePadding: true,
    label: 'Défaut',
    transform: booleanValue
  },
  {
    id: 'tax_enabled',
    bool: true,
    disablePadding: true,
    label: 'Actif',
    transform: booleanValue
  }
]
export default class AdminTaxesComponent extends Component {
  static propTypes = {
    taxes: PropTypes.array.isRequired,
    showModal: PropTypes.func.isRequired,
    refreshTaxes: PropTypes.func.isRequired
  }
  state = {
    columnData: []
  }
  handleEditPricingClick = taxe => {
    this.props.showModal(MODAL_ADMIN_EDIT_TAXE)
  }

  handleReorderClick = () => {}

  componentDidMount() {
    if (this.props.taxes.length === 0) {
      this.props.refreshTaxes()
    }
  }
  componentWillMount() {
    this.setState({ columnData: defaultColumnData })
  }
  render() {
    const { taxes } = this.props
    const { columnData } = this.state
    return (
      <AdminTableComponent
        title="Taux de TVA"
        search={['tax_name', 'tax_value']}
        readOnly
        list={taxes}
        orderBy={'tax_value'}
        columnData={columnData}
        editButtonAction={this.handleEditPricingClick}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/Admin/Settings/components/taxes/AdminTaxesComponent.js